import React, { useState, Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Logo from '../../../assets/images/logo.png';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  GetChangePass,
  selectChangePass
} from '../../../features/login/ChangePassSlice';
import '../login.css';
import swal from 'sweetalert';
import { dev } from '../../../features/network/ApiCall';
import { LogoutUser } from '../../../constant/Logout';
var md5 = require('md5');

class ChangePassowrd extends Component {
  constructor() {
    super();
    this.state = {
      oldPass: '',
      newPass: '',
      confirmPass: '',
      disabled: true,
      changePassUserId: ''
    };

    this.handleChange1 = (event) => {
      this.setState({
        newPass: event.target.value
      });
    };

    this.handleChange2 = (event) => {
      this.setState({
        confirmPass: event.target.value,
        disabled: false
      });
    };
    this.handleChange3 = (event) => {
      this.setState({
        oldPass: event.target.value
      });
    };
  }

  async componentDidMount() {
    var userDetails = localStorage.getItem('userDetails');
    var userDetailsList = userDetails;
    var userDetailsJson = JSON.parse(userDetailsList);
    await this.setState({
      changePassUserId: userDetailsJson.UserId
    });
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    var userDetails = localStorage.getItem('userDetails');
    var userDetailsList = userDetails;
    var userDetailsJson = JSON.parse(userDetailsList);
    let data = {
      userId: this.state.changePassUserId,
      oldPassword: md5(this.state.oldPass),
      newPassword: md5(this.state.newPass)
    };

    var axios = require('axios');
    var config = {
      method: 'post',
      url: `${dev}/users/user/resetPassword`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userDetailsJson.accessToken
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        swal('Password Change Success!', '', 'success');
        //LogoutUser();
        localStorage.removeItem('userDetails');
        localStorage.removeItem('otp');
        localStorage.removeItem('forgetpass');
        localStorage.removeItem('isSSO');
        localStorage.removeItem('URP');
        localStorage.removeItem('store');
        localStorage.removeItem('isSession');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('userPhotoDetails');
        // window.location.href = `${dev}/api/users/user/logout?accessToken=${userDetailsJson.accessToken}`;
        //   window.location.href="users/user/logout"
        LogoutUser();
      })
      .catch(function (error) {
        // console.log(error);
        swal('Something went wrong!', 'error');
      });
  };
  render() {
    let colour1 = 'red',
      colour2 = 'red',
      colour3 = 'red',
      colour4 = 'red',
      colour5 = 'red';
    // if(this.state.newPass.length >= "8")
    // {
    //     colour1="green";
    // }
    // if(this.state.newPass.match(/[A-Z]/))
    // {
    //     colour2="green";
    // }
    // if(this.state.newPass.match(/[a-z]/))
    // {
    //     colour3="green";
    // }
    if (
      this.state.newPass.match(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      )
    ) {
      colour4 = 'green';
    }
    if (
      this.state.newPass === this.state.confirmPass &&
      this.state.newPass !== ''
    ) {
      colour5 = 'green';
    }

    const style = {
      boxShadow: '2px 2px 3px 3px #ccc',
      border: '2px #eee',
      padding: '20px',
      marginTop: '25px'
    };

    return (
      <>
        <Container fluid style={{ height: 'auto' }}>
          <Row sm={3}>
            <Col></Col>
            <Col
              className='bg-white box-shadow tb-mar-mob0-desk48 mx-auto cp'
              xxl={4}
              xs={10}
            >
              <Image
                className='mx-auto d-block'
                style={styles.limg}
                src={Logo}
              />
              <div className='mt-2 mb-3' style={styles.head}>
                Ethics and governance portal
              </div>
              <form onSubmit={this.handleSubmit}>
                {/* <p style={{fontWeight:"bold"}}>Password must have:8 characters, 1 uppercase letter, 1 lowercase letter, 1 number or special character</p> */}
                {/* <p><i style={{color:colour1,fontSize:"20px"}} className="fa fa-check-circle" aria-hidden="true"></i> At least 8 characters</p>
          <p><i style={{color:colour2,fontSize:"20px"}} className="fa fa-check-circle" aria-hidden="true"></i> At least 1 uppercase letter</p>
          <p><i style={{color:colour3,fontSize:"20px"}} className="fa fa-check-circle" aria-hidden="true"></i> At least 1 lowercase letter</p> */}
                <p>
                  <i
                    style={{ color: colour4, fontSize: '20px' }}
                    className='fa fa-check-circle'
                    aria-hidden='true'
                  ></i>{' '}
                  Password must have:8 characters, 1 uppercase letter, 1
                  lowercase letter, 1 number or special character
                </p>
                {/* <p><i style={{color:colour5,fontSize:"20px"}} className="fa fa-check-circle" aria-hidden="true"></i> Password === Confirm Password</p> */}
                <div className='form-group'>
                  <label for='password'>Old Password</label>
                  <input
                    type='password'
                    className='form-control'
                    value={this.state.oldPass}
                    onChange={this.handleChange3}
                    placeholder=''
                  />
                </div>
                <div className='form-group'>
                  <label for='password'>New Password</label>
                  <input
                    type='password'
                    className='form-control'
                    value={this.state.newPass}
                    onChange={this.handleChange1}
                    placeholder=''
                  />
                </div>
                <div className='form-group'>
                  <label for='password'>Confirm Password</label>
                  <input
                    type='password'
                    className='form-control'
                    value={this.state.confirmPass}
                    onChange={this.handleChange2}
                    placeholder=''
                  />
                </div>
                {this.state.confirmPass === '' ? (
                  ''
                ) : this.state.newPass === this.state.confirmPass ? (
                  <p style={{ color: 'green', fontWeight: 'bold' }}>
                    {' '}
                    Passwords match{' '}
                  </p>
                ) : (
                  <p style={{ color: 'red', fontWeight: 'bold' }}>
                    {' '}
                    Passwords not match{' '}
                  </p>
                )}
                <Button
                  // href="/home"
                  className='mt-2'
                  style={styles.btn1}
                  variant='danger'
                  type='submit'
                  disabled={this.state.disabled}
                >
                  SUBMIT
                </Button>
              </form>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      </>
    );
  }
}

const styles = {
  head: {
    fontFamily: 'Saira',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center'
  },
  limg: {
    width: '159px',
    height: '22px'
  },

  btn1: {
    width: '100%',
    height: '48px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px',
    padding: '15px'
  }
};

export default ChangePassowrd;
